module.exports = __webpack_public_path__ + "icon_reply-4f6ada7a0b886b084706a484753a0ff0.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mailer/icon_reply.png
// module id = 278
// module chunks = 86